import { useState, useEffect } from 'react'
import { fetchSearchResults } from 'state/actions'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { H, P } from '@farewill/ui'
import IconList from 'components/icon-list'
import { AircallEventAttributes } from 'lib/models/aircall-event'
import { Contact } from 'lib/models/contact'
import { getAircallContactName, getFullName } from 'utils/helpers'

export type ContactSearchResult = {
  id: number
  attributes: Contact
}

const ResultsList = ({
  searchResults,
}: {
  searchResults: ContactSearchResult[]
}) => {
  const hasResults = searchResults.length > 0
  if (!hasResults) return <P>No results</P>

  return (
    <IconList
      items={searchResults.map((result) => (
        <span key={result.id}>
          <Link to={`/contacts/${result.id}`}>
            {getFullName(result.attributes)}
          </Link>
          <P size="S">{result.attributes.email || 'No email address'}</P>
        </span>
      ))}
    />
  )
}

const Suggestions = ({
  call,
  searchResults,
}: {
  call: AircallEventAttributes
  searchResults: ContactSearchResult[]
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    const contactName = getAircallContactName(call.contact)
    if (!contactName) return
    const fetchResults = async () => {
      setIsLoading(true)
      await dispatch(fetchSearchResults(contactName))
      setIsLoading(false)
    }

    fetchResults()
  }, [call.contact, dispatch])

  if (!call.contact) return null

  return (
    <>
      <H size="S" decorative>
        Searching existing contacts for "{getAircallContactName(call.contact)}"
      </H>
      {isLoading ? (
        <P>Loading...</P>
      ) : (
        <ResultsList searchResults={searchResults} />
      )}
    </>
  )
}

export default Suggestions
